import axios from 'axios';
import ShopifyImage from '../../../services/shopify/ShopifyImageService';

export default {
  namespaced: true,

  state: {
    product: null,
    productHandle: null,
  },

  getters: {
    title: state => {
      return state.product ? state.product.title : null;
    },

    image: state => {
      if (!state.product) return null;

      let image = state.product.featured_image || null;

      if (!image) {
        const images = state.product.images;
        image = (images && images.length) ? images[0] : null;
      }

      return ShopifyImage.size(image, 224, 224);
    },

    handle: state => {
      return state.productHandle;
    },

    get: state => {
      return state.product;
    },
  },

  mutations: {
    handle: (state, payload) => {
      state.productHandle = payload;
    },

    set: (state, payload) => {
      state.product = payload;
    },
  },

  actions: {
    async init({commit, dispatch, rootGetters}) {
      commit('set', null);

      // we can get current product only from product page
      const pageType = rootGetters['shopify/page/type'];
      if (pageType !== 'product') return;

      await dispatch('initProductHandle');
      await dispatch('loadProductByHandle');
    },

    async initProductHandle({commit}) {
      const handle = window.location.pathname.substr(window.location.pathname.lastIndexOf('/') + 1);
      commit('handle', handle);
    },

    async loadProductByHandle({commit, getters}) {
      // get product handle from current url and load product from shopify
      const handle = getters['handle'];
      if (!handle) {
        return;
      }

      const baseUrl = window.location.origin;
      console.log(`${baseUrl}/products/${handle}.js`);
      await axios.get(`${baseUrl}/products/${handle}.js`)
        .then(response => {
          commit('set', response.data);
        });
    },

  },
};
